import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Container, Flex, HStack, Image, VStack, Text, Button, InputGroup, Input, PinInput, PinInputField, InputLeftElement, FormControl, FormLabel, useDisclosure, FormErrorMessage, } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { useEffect, useRef, useState } from "react";
import { useCustomToast } from "../components/useCustomToast";
import LottieAnimation from "../components/LottieAnimation";
import SwipeDownDrawer from "../components/drawers/SwipeDownDrawer";
import BackNavigation from "../components/BackNavigation";
import { useLocation, useNavigate, useSearchParams, } from "react-router-dom";
import API from "../shared-utils/api";
import { ChevronDownIcon, EmailIcon } from "@chakra-ui/icons";
import { useCustomer } from "../contexts/CustomerProvider";
import { IMG_URL } from "../components/common/Constant";
import { countryOptions } from "../shared-utils/values";
import { API_ENDPOINTS } from "../shared-constants";
import { FaWhatsapp } from "react-icons/fa";
import { FiUser } from "react-icons/fi";
import ReactCountryFlag from "react-country-flag";
const pulse = keyframes `
  0% { transform: scale(1); opacity: 0.6; }
  50% { transform: scale(1.15); opacity: 0.9; }
  100% { transform: scale(1); opacity: 0.6; }
`;
const LogoWithGlow = ({ imageName }) => {
    return (_jsxs(Box, { position: "relative", w: "120px", h: "120px", mb: 8, children: [_jsx(Box, { position: "absolute", inset: 0, borderRadius: "full", bg: "radial-gradient(circle, rgba(129,85,254,0.8) 0%, transparent 80%)", filter: "blur(20px)", zIndex: 0, animation: `${pulse} 3s ease-in-out infinite` }), _jsx(Image, { src: `${IMG_URL}/${imageName}`, alt: "Logo", zIndex: 1, position: "relative", w: "100%", h: "100%", objectFit: "contain" })] }));
};
const VerifyPhone = ({ onLoginSuccess, defaultRedirectPath = "/home", }) => {
    var _a, _b, _c;
    const customToast = useCustomToast();
    const navigate = useNavigate();
    const location = useLocation();
    const { source } = location.state || {};
    const isSmsOnly = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.isSmsOnly) || false;
    const [searchParams, setSearchParams] = useSearchParams();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { login, customerData } = useCustomer();
    const [selectedCountry, setSelectedCounter] = useState({
        countryCode: "IN",
        label: "+91 (India)",
        value: "91",
    });
    const [userPhone, setUserPhone] = useState("");
    const [userName, setUserName] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [otpDisabled, setOtpDisabled] = useState(true);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [verifyDisabled, setVerifyDisabled] = useState(true);
    const [disableUserName, setDisableUserName] = useState(false);
    const [otp, setOtp] = useState("");
    const [userUid, setUserUid] = useState("");
    const [resendDisabled, setResendDisabled] = useState(false);
    const [otpResent, setOtpResent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [otpLength, setOtpLength] = useState(4);
    const [turnstileToken, setTurnstileToken] = useState("");
    const [turnstileWidgetId, setTurnstileWidgetId] = useState("");
    const turnstileContainerRef = useRef(null);
    const turnstileTokenResolverRef = useRef(null);
    const countryCode = (_b = selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.value) !== null && _b !== void 0 ? _b : "";
    const phoneLength = (_c = userPhone === null || userPhone === void 0 ? void 0 : userPhone.length) !== null && _c !== void 0 ? _c : 0;
    const isIndia = countryCode === "91";
    const isTurnstileEnabled = process.env.REACT_APP_TURNSTILE_ENABLED === "true";
    const isPhoneInvalid = (countryCode === "91" && phoneLength > 0 && phoneLength !== 10) ||
        (countryCode !== "91" &&
            phoneLength > 0 &&
            (phoneLength < 7 || phoneLength > 15));
    const isNameInvalid = userName.length > 0 &&
        (/[^a-zA-Z0-9\s]/.test(userName) || !/[a-zA-Z]/.test(userName));
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailInvalid = !isIndia && userEmail.length > 0 && !emailRegex.test(userEmail);
    const isEmailDisabled = !isIndia &&
        (!userName || !userPhone || !userEmail || isPhoneInvalid || isEmailInvalid);
    useEffect(() => {
        if (localStorage.getItem("is_phone_verified") && (customerData === null || customerData === void 0 ? void 0 : customerData.id)) {
            const raw = new URLSearchParams(location.search).get("redirect");
            if (raw) {
                const decoded = decodeURIComponent(raw);
                navigate(decoded, { replace: true });
            }
            else {
                navigate(defaultRedirectPath);
            }
        }
    }, [customerData]);
    useEffect(() => {
        const otpSentParam = searchParams.get("otpsent");
        setIsOtpSent(otpSentParam === "true");
        const name = searchParams.get("name");
        if (name)
            setUserName(name);
        const email = searchParams.get("email");
        if (email) {
            setUserEmail(email);
            if (!name) {
                const emailPrefix = email.split("@")[0];
                if (emailPrefix) {
                    setUserName(emailPrefix);
                }
            }
        }
        const phone = searchParams.get("phone");
        if (phone)
            setUserPhone(phone);
        const uidParam = searchParams.get("uid");
        if (uidParam)
            setUserUid(uidParam);
        const countryCodeParam = searchParams.get("co");
        const countryOption = countryCodeParam
            ? countryOptions.find((item) => item.value === countryCodeParam)
            : null;
        if (countryOption) {
            setSelectedCounter(countryOption);
        }
        const otpSentAt = searchParams.get("otpSentAt");
        let timerId;
        if (otpSentAt) {
            const timePassed = Date.now() - Number(otpSentAt);
            const remaining = 30000 - timePassed;
            if (remaining > 0) {
                setResendDisabled(true);
                timerId = setTimeout(() => {
                    setResendDisabled(false);
                    if (isTurnstileEnabled && window.turnstile && turnstileWidgetId) {
                        window.turnstile.reset(turnstileWidgetId);
                    }
                }, remaining);
            }
            else {
                setResendDisabled(false);
                if (isTurnstileEnabled && window.turnstile && turnstileWidgetId) {
                    window.turnstile.reset(turnstileWidgetId);
                }
            }
        }
        return () => {
            if (timerId)
                clearTimeout(timerId);
        };
    }, [searchParams, turnstileWidgetId]);
    useEffect(() => {
        if (isOtpSent) {
            searchParams.set("otpsent", isOtpSent.toString());
            searchParams.set("name", userName);
            searchParams.set("email", userEmail);
            searchParams.set("phone", userPhone);
            searchParams.set("uid", userUid);
            searchParams.set("otpSentAt", Date.now().toString());
            navigate({ search: "?" + searchParams.toString() }, { state: { isSmsOnly }, replace: true });
            const resendTimer = setTimeout(() => {
                setResendDisabled(false);
                if (isTurnstileEnabled && window.turnstile && turnstileWidgetId) {
                    window.turnstile.reset(turnstileWidgetId);
                }
            }, 30000);
            return () => {
                if (resendTimer)
                    clearTimeout(resendTimer);
            };
        }
    }, [isOtpSent, turnstileWidgetId]);
    useEffect(() => {
        if (otp && otp.length === otpLength) {
            setVerifyDisabled(false);
            verifyOtp();
        }
    }, [otp]);
    // Initialize Turnstile widget
    useEffect(() => {
        if (!isTurnstileEnabled) {
            return;
        }
        const initTurnstile = () => {
            if (window.turnstile &&
                turnstileContainerRef.current &&
                !turnstileWidgetId) {
                const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";
                if (!siteKey) {
                    console.error("Turnstile site key is not configured");
                    return;
                }
                try {
                    const widgetId = window.turnstile.render(turnstileContainerRef.current, {
                        sitekey: siteKey,
                        theme: "dark",
                        size: "invisible",
                        callback: (token) => {
                            setTurnstileToken(token);
                            if (turnstileTokenResolverRef.current) {
                                turnstileTokenResolverRef.current(token);
                                turnstileTokenResolverRef.current = null;
                            }
                        },
                        "error-callback": () => {
                            customToast({
                                title: "Verification failed. Please try again.",
                                status: "error",
                            });
                            setIsLoading(false);
                            if (turnstileTokenResolverRef.current) {
                                turnstileTokenResolverRef.current("");
                                turnstileTokenResolverRef.current = null;
                            }
                        },
                        "timeout-callback": () => {
                            customToast({
                                title: "Verification timeout. Please try again.",
                                status: "error",
                            });
                            setIsLoading(false);
                            if (turnstileTokenResolverRef.current) {
                                turnstileTokenResolverRef.current("");
                                turnstileTokenResolverRef.current = null;
                            }
                        },
                        "expired-callback": () => {
                            setTurnstileToken("");
                        },
                    });
                    setTurnstileWidgetId(widgetId);
                }
                catch (error) {
                    console.error("Error initializing Turnstile:", error);
                }
            }
        };
        if (window.turnstile) {
            initTurnstile();
        }
        else {
            const checkTurnstile = setInterval(() => {
                if (window.turnstile) {
                    clearInterval(checkTurnstile);
                    initTurnstile();
                }
            }, 100);
            return () => clearInterval(checkTurnstile);
        }
        return () => {
            if (window.turnstile && turnstileWidgetId) {
                try {
                    window.turnstile.remove(turnstileWidgetId);
                }
                catch (error) {
                    console.error("Error removing Turnstile widget:", error);
                }
            }
        };
    }, [turnstileWidgetId, isTurnstileEnabled]);
    const userLogin = async (otpSessionToken) => {
        const currentUrl = window.location.href;
        const redirectParam = new URLSearchParams(location.search).get("redirect");
        let finalSourceUrl = source || "";
        if (currentUrl.includes("secure") && redirectParam) {
            const decodedRedirect = decodeURIComponent(redirectParam);
            if (decodedRedirect.startsWith("http://") ||
                decodedRedirect.startsWith("https://")) {
                finalSourceUrl = decodedRedirect;
            }
            else {
                const cleanPath = decodedRedirect.startsWith("/")
                    ? decodedRedirect
                    : `/${decodedRedirect}`;
                finalSourceUrl = `${window.location.origin}${cleanPath}`;
            }
        }
        const { data, status } = await API.post(API_ENDPOINTS.USERS.SECURE_LOGIN, {
            email: userEmail,
            name: userName,
            phoneNumber: userPhone,
            countryCode: selectedCountry.value || "91",
            source_url: finalSourceUrl,
            otpSessionToken,
        });
        if (status === 200) {
            login();
            redirectUser();
        }
    };
    const redirectUser = () => {
        const raw = new URLSearchParams(location.search).get("redirect");
        if (raw) {
            const decoded = decodeURIComponent(raw);
            navigate(decoded, { replace: true });
        }
        else if (onLoginSuccess) {
            onLoginSuccess(navigate);
        }
        else {
            navigate(defaultRedirectPath);
        }
    };
    const executeTurnstile = () => {
        return new Promise((resolve, reject) => {
            if (!window.turnstile || !turnstileWidgetId) {
                reject(new Error("Turnstile not initialized"));
                return;
            }
            turnstileTokenResolverRef.current = resolve;
            const timeout = setTimeout(() => {
                if (turnstileTokenResolverRef.current) {
                    turnstileTokenResolverRef.current = null;
                    reject(new Error("Turnstile verification timeout"));
                }
            }, 10000);
            try {
                window.turnstile.execute(turnstileWidgetId);
            }
            catch (error) {
                clearTimeout(timeout);
                turnstileTokenResolverRef.current = null;
                reject(error);
            }
            const originalResolve = resolve;
            turnstileTokenResolverRef.current = (token) => {
                clearTimeout(timeout);
                originalResolve(token);
            };
        });
    };
    const sendOtp = async (resend) => {
        if (!userPhone)
            return;
        if (userName) {
            const specialCharsPattern = /[^a-zA-Z0-9\s]/g;
            const specialChars = userName.match(specialCharsPattern);
            if (specialChars && specialChars.length > 0) {
                const uniqueSpecialChars = Array.from(new Set(specialChars));
                const specialCharsDisplay = uniqueSpecialChars.join(", ");
                customToast({
                    title: `Special characters "${specialCharsDisplay}" are not allowed in name.`,
                    status: "error",
                });
                return;
            }
            if (!/[a-zA-Z]/.test(userName)) {
                customToast({
                    title: "Name must contain at least one letter.",
                    status: "error",
                });
                return;
            }
        }
        setIsLoading(true);
        if (resend) {
            setResendDisabled(true);
        }
        try {
            let token = "";
            if (isTurnstileEnabled) {
                if (resend && window.turnstile && turnstileWidgetId) {
                    turnstileTokenResolverRef.current = null;
                    window.turnstile.reset(turnstileWidgetId);
                    setTurnstileToken("");
                    await new Promise((resolve) => setTimeout(resolve, 100));
                }
                token = await executeTurnstile();
                if (!token) {
                    throw new Error("Failed to get Turnstile verification token");
                }
            }
            const requestBody = {
                phoneNumber: userPhone,
                name: userName,
                countryCode: selectedCountry.value || "91",
                resend: resend || undefined,
            };
            if (isTurnstileEnabled && token) {
                requestBody.turnstileToken = token;
            }
            if (userEmail) {
                requestBody.email = userEmail;
            }
            const { data, status } = await API.post(API_ENDPOINTS.USERS.SEND_OTP, requestBody);
            if (data.status_code === "OK") {
                setIsOtpSent(true);
                setUserUid(data.data);
                customToast({
                    title: "OTP sent successfully!",
                    status: "success",
                });
                if (isTurnstileEnabled && window.turnstile && turnstileWidgetId) {
                    window.turnstile.reset(turnstileWidgetId);
                }
                setTurnstileToken("");
                if (resend) {
                    setTimeout(() => {
                        setResendDisabled(false);
                    }, 30000);
                }
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
                setResendDisabled(false);
                if (isTurnstileEnabled && window.turnstile && turnstileWidgetId) {
                    window.turnstile.reset(turnstileWidgetId);
                }
                setTurnstileToken("");
                customToast({
                    title: data.status_message || "Error sending OTP. Please try again.",
                    status: "error",
                });
            }
        }
        catch (err) {
            setIsLoading(false);
            setResendDisabled(false);
            if (isTurnstileEnabled && window.turnstile && turnstileWidgetId) {
                window.turnstile.reset(turnstileWidgetId);
            }
            setTurnstileToken("");
            customToast({
                title: (err === null || err === void 0 ? void 0 : err.message) || "Error sending OTP. Please try again.",
                status: "error",
            });
        }
    };
    const fetchCustomerName = async (phoneNumber) => {
        var _a;
        if (!phoneNumber || phoneNumber.length < 7)
            return;
        try {
            const { data } = await API.get(API_ENDPOINTS.USERS.GET_CUSTOMER(phoneNumber));
            if ((data === null || data === void 0 ? void 0 : data.status_code) === "OK" && (data === null || data === void 0 ? void 0 : data.data)) {
                const name = (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : "";
                const isValidName = /^[a-zA-Z0-9\s]+$/.test(name);
                if (isValidName) {
                    setUserName(name);
                    setDisableUserName(true);
                }
                else {
                    setDisableUserName(false);
                }
            }
            else {
                setDisableUserName(false);
            }
        }
        catch (err) {
            setDisableUserName(false);
        }
    };
    const verifyOtp = async () => {
        setIsLoading(true);
        try {
            const { data, status } = await API.get(API_ENDPOINTS.USERS.VERIFY_OTP(userUid, otp));
            if (data.status_code === "OK") {
                userLogin(data.data);
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
                customToast({
                    title: "Incorrect OTP!",
                    status: "error",
                });
            }
        }
        catch (err) {
            setIsLoading(false);
            customToast({
                title: "Incorrect OTP!",
                status: "error",
            });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(BackNavigation, {}), _jsx(Box, { bg: "rgba(0, 0, 0, 0.7)", backdropFilter: "blur(12px)", w: "100%", h: "100%", overflow: "hidden", position: "relative", children: _jsxs(Container, { w: ["100%", "100%", "100%", "400px"], minH: "100vh", background: "#111111", p: "0", overflow: "hidden", position: "relative", pb: 24, children: [!isOtpSent ? (_jsxs(Flex, { flexDir: "column", mt: 24, justifyContent: "center", alignItems: "center", children: [_jsx(LogoWithGlow, { imageName: "background/zillout-logo.svg" }), _jsxs(VStack, { children: [_jsx(Text, { color: "#8155FE", fontSize: "14px", fontWeight: "400", children: "Let us open the doors for you!" }), _jsx(Text, { color: "white", fontSize: "18px", fontWeight: "600", children: "Tell us who's stepping in" })] }), _jsxs(VStack, { mt: 10, justifyContent: "center", alignItems: "center", w: "full", spacing: 8, px: 4, children: [_jsx(Flex, { flexDir: "column", w: "100%", maxW: "400px", children: _jsxs(FormControl, { children: [_jsx(FormLabel, { color: "gray.100", fontSize: "12px", fontWeight: "400", mb: 2, children: "Country Code" }), _jsxs(Box, { bg: "#212121", borderColor: "#4E4E4E", borderWidth: "1px", px: 3, borderRadius: "md", color: "white", display: "flex", alignItems: "center", justifyContent: "space-between", w: "full", py: "10px", cursor: "pointer", onClick: onOpen, children: [_jsxs(Flex, { align: "center", gap: 2, children: [_jsx(ReactCountryFlag, { svg: true, countryCode: selectedCountry.countryCode, style: { width: "1.5em", height: "1.5em" } }), _jsx(Text, { fontSize: "14px", fontWeight: 400, children: selectedCountry.label })] }), _jsx(ChevronDownIcon, { boxSize: "7", color: "#8155FE" })] })] }) }), _jsx(Flex, { flexDir: "column", w: "100%", maxW: "400px", gap: 4, children: _jsxs(FormControl, { isInvalid: isPhoneInvalid, children: [_jsx(FormLabel, { color: "gray.100", fontSize: "12px", fontWeight: "400", mb: 2, children: isSmsOnly ? "Phone Number" : "WhatsApp Number" }), _jsxs(InputGroup, { children: [_jsx(InputLeftElement, { pointerEvents: "none", height: "100%", pl: 5, gap: 5, children: _jsxs(HStack, { spacing: 1, align: "center", children: [_jsx(Box, { mt: "2px", children: _jsx(FaWhatsapp, { color: "#25D366", size: "18px" }) }), _jsxs(Text, { color: "#9D9D9D", fontSize: "14px", fontWeight: 400, children: ["+", selectedCountry.value] })] }) }), _jsx(Input, { type: "tel", bg: "#212121", borderColor: "#4E4E4E", placeholder: isSmsOnly ? "Phone Number" : "WhatsApp Number", color: "white", fontSize: "14px", fontWeight: 400, _placeholder: {
                                                                    color: "#9D9D9D",
                                                                    fontSize: "14px",
                                                                    fontWeight: 400,
                                                                }, pl: "60px", py: "22px", value: userPhone, onChange: (ev) => {
                                                                    const maxLen = selectedCountry.value === "91" ? 10 : 15;
                                                                    let digits = ev.target.value.replace(/\D/g, "");
                                                                    const cc = selectedCountry.value;
                                                                    if (digits.length > maxLen && digits.startsWith(cc)) {
                                                                        digits = digits.slice(cc.length);
                                                                    }
                                                                    const value = digits.slice(0, maxLen);
                                                                    setUserPhone(value);
                                                                    setUserName("");
                                                                    setDisableUserName(false);
                                                                    if (selectedCountry.value === "91") {
                                                                        setOtpDisabled(value.length !== 10);
                                                                        if (value.length === 10) {
                                                                            fetchCustomerName(value);
                                                                        }
                                                                    }
                                                                    else {
                                                                        setOtpDisabled(value.length < 7 || value.length > 15);
                                                                        if (value.length >= 7 && value.length <= 15) {
                                                                            fetchCustomerName(value);
                                                                        }
                                                                    }
                                                                } })] }), isPhoneInvalid && (_jsx(FormErrorMessage, { fontSize: "12px", mt: 1, fontWeight: "500", children: selectedCountry.value === "91"
                                                            ? "Phone number must be exactly 10 digits."
                                                            : "Phone number should be between 7 and 15 digits." }))] }) }), selectedCountry.value === "91" && (_jsx(Flex, { flexDir: "column", w: "100%", maxW: "400px", children: _jsxs(FormControl, { isInvalid: isNameInvalid, children: [_jsx(FormLabel, { color: "gray.100", fontSize: "12px", fontWeight: "400", mb: 2, children: "Full Name" }), _jsxs(InputGroup, { children: [_jsx(InputLeftElement, { mt: 0.5, pointerEvents: "none", children: _jsx(FiUser, { size: "18px", color: "#9F7AEA" }) }), _jsx(Input, { type: "text", placeholder: "Enter your full name", bg: "#212121", borderColor: "#4E4E4E", py: "22px", fontSize: "14px", fontWeight: 400, color: "white", _placeholder: { color: "#9D9D9D" }, pl: "45px", disabled: disableUserName, value: userName, onChange: (ev) => setUserName(ev.target.value.replace(/[^a-zA-Z0-9\s]/g, "")) })] }), isNameInvalid && (_jsx(FormErrorMessage, { fontSize: "12px", mt: 1, fontWeight: "500", children: "Name must contain at least one letter." }))] }) })), selectedCountry.value !== "91" && (_jsx(Flex, { flexDir: "column", w: "100%", maxW: "400px", children: _jsxs(FormControl, { isInvalid: isEmailInvalid, children: [_jsx(FormLabel, { color: "gray.100", fontSize: "12px", fontWeight: "400", mb: 2, children: "Email Address" }), _jsxs(InputGroup, { children: [_jsx(InputLeftElement, { mt: 0.5, pointerEvents: "none", children: _jsx(EmailIcon, { color: "#9F7AEA", boxSize: "18px" }) }), _jsx(Input, { type: "email", placeholder: "Enter your email address", bg: "#212121", borderColor: "#4E4E4E", py: "22px", fontSize: "14px", fontWeight: 400, color: "white", _placeholder: { color: "#9D9D9D" }, pl: "45px", value: userEmail, onChange: (ev) => {
                                                                    const email = ev.target.value;
                                                                    setUserEmail(email);
                                                                    const emailPrefix = email.split("@")[0];
                                                                    if (emailPrefix) {
                                                                        setUserName(emailPrefix);
                                                                    }
                                                                } })] }), isEmailInvalid && (_jsx(FormErrorMessage, { fontSize: "12px", mt: 1, fontWeight: "500", children: "Please enter a valid email address." }))] }) }))] })] })) : isOtpSent ? (_jsxs(Flex, { flexDir: "column", mt: 24, justifyContent: "center", alignItems: "center", children: [_jsx(LogoWithGlow, { imageName: "background/secure.svg" }), _jsx(Text, { fontSize: "18px", fontWeight: "600", color: "white", children: "Enter the OTP" }), _jsx(Text, { mt: 6, fontSize: "12px", fontWeight: "400", color: "white", children: selectedCountry.value === "91"
                                        ? `OTP was sent to +${selectedCountry.value}-${userPhone} on ${otpResent ? "SMS" : "WhatsApp"}`
                                        : `OTP was sent to ${userEmail}` }), _jsxs(VStack, { children: [_jsx(HStack, { mt: 6, spacing: otpLength == 4 ? 4 : 2, children: _jsx(PinInput, { autoFocus: true, value: otp || "", otp: true, onChange: (value) => setOtp(value), type: "number", mask: false, children: [...Array(otpLength)].map((_, i) => (_jsx(PinInputField, { w: "50px", h: "60px", fontSize: "16px", fontWeight: "500", bg: "gray.900", border: "2px solid", borderColor: "gray.700", color: "white", _focus: { borderColor: "purple.400" } }, i))) }) }), _jsx(Text, { fontSize: "12px", fontWeight: "400", color: "white", pt: 8, children: "Didn't receive OTP yet? Get it via SMS" }), _jsx(Button, { variant: "link", fontSize: "14px", fontWeight: "600", mt: 0, color: "#A383FF", cursor: "pointer", _hover: { textDecoration: "underline" }, onClick: () => {
                                                setOtp("");
                                                sendOtp(true);
                                                setOtpResent(true);
                                            }, p: 0, isDisabled: resendDisabled, children: "Resend OTP" }), _jsxs(HStack, { w: "full", maxW: "200px", alignItems: "center", py: 6, children: [_jsx(Box, { flex: 1, h: "1px", bg: "gray.600" }), _jsx(Text, { fontSize: "xs", color: "gray.400", children: "OR" }), _jsx(Box, { flex: 1, h: "1px", bg: "gray.600" })] }), _jsx(Button, { variant: "link", color: "purple.400", fontSize: "sm", fontWeight: "bold", onClick: () => navigate("/verify-phone/", { replace: true }), _hover: { textDecoration: "underline" }, p: 0, h: "auto", children: selectedCountry.value === "91"
                                                ? "Change Number"
                                                : "Change Email" })] })] })) : null, _jsx(Box, { ref: turnstileContainerRef, visibility: "hidden", position: "absolute" }), isLoading ? (_jsx(Flex, { w: "100vw", h: "100%", alignItems: "center", justifyContent: "center", position: "absolute", top: 0, left: 0, backdropFilter: "blur(12px)", bg: "blackAlpha.700", zIndex: 2, children: _jsx(LottieAnimation, {}) })) : null] }) }), _jsx(Flex, { position: "fixed", bottom: 0, w: ["100%", "100%", "100%", "400px"], left: [0, 0, 0, "calc((100% - 400px)/ 2)"], background: "#212121", children: isOtpSent ? (_jsx(Button, { _hover: { bg: "#8155FE", textColor: "white" }, w: ["100%"], h: "60px", background: "#8155FE", textColor: "white", fontSize: "14px", fontWeight: "600", isDisabled: verifyDisabled, isLoading: isLoading, onClick: verifyOtp, children: "Verify OTP" })) : selectedCountry.value === "91" ? (_jsx(Button, { _hover: { bg: "#8155FE", textColor: "white" }, w: ["100%"], h: "60px", fontSize: "14px", fontWeight: "600", background: "#8155FE", textColor: "white", isDisabled: userName ? (otpDisabled || isNameInvalid) : true, isLoading: isLoading, onClick: () => sendOtp(false), children: "Send OTP" })) : (_jsx(Button, { _hover: { bg: "#8155FE", textColor: "white" }, w: ["100%"], h: "60px", fontSize: "14px", fontWeight: "600", background: "#8155FE", textColor: "white", isDisabled: isEmailDisabled, isLoading: isLoading, onClick: () => sendOtp(false), children: "Verify Email" })) }), _jsx(SwipeDownDrawer, { isOpen: isOpen, onOpen: onOpen, onClose: onClose, header: "Select Country Code", content: _jsx(VStack, { align: "stretch", spacing: 3, px: 4, pb: 6, h: "80vh", overflowY: "auto", children: countryOptions.map((country) => (_jsx(Box, { p: 3, borderRadius: "12px", bg: selectedCountry.value === country.value
                            ? "#8155FE26"
                            : "#1E1E1E", borderWidth: selectedCountry.value === country.value ? "1px" : "", borderColor: selectedCountry.value === country.value ? "#8155FE" : "", _hover: { bg: "#333", cursor: "pointer" }, onClick: () => {
                            setSelectedCounter(country);
                            onClose();
                        }, children: _jsxs(Flex, { align: "center", gap: 3, children: [_jsx(ReactCountryFlag, { svg: true, countryCode: country.countryCode, style: { width: "1.5em", height: "1.5em" } }), _jsx(Text, { color: "white", fontSize: "14px", children: country.label })] }) }, country.value))) }) })] }));
};
export default VerifyPhone;
